import { useQuery } from '@tanstack/react-query'
import { getFeatureConfigKey } from 'common/constants/queryKeys'

import { getFeatureConfig } from '.'

export const useFeatureEnabled = (key: string) =>
  useQuery<boolean>({
    queryKey: getFeatureConfigKey(key),
    queryFn: async () => {
      try {
        const { data } = await getFeatureConfig(key)
        return data.data.enabled
      } catch {
        return false
      }
    },
    staleTime: 5 * 60 * 1000,
  })
